import { Excess, PaymentFrequency } from 'scenes/common/types';
import { CoverOptionsData } from 'scenes/landlord/types';

export const defaultExcess: Excess = {
  id: '',
  type: '',
  amount: 0,
};

export const defaultLandlordCoverOptions: CoverOptionsData = {
  preselectedPaymentFrequency: PaymentFrequency.Annually,
  selectedExtras: [],
};
